import { Pipe, PipeTransform } from '@angular/core';
import { Realisation } from 'src/app/classes/realisation';
import { AuthorisationService } from 'src/app/services/auth/authorisation.service';
import { Functionalities } from 'src/app/services/auth/functionalities';
import { Utils } from '../../utils.class';

@Pipe({
    name: 'notApprovable',
})
export class NotApprovablePipe implements PipeTransform {
    transform(realisation: Realisation): unknown {
        if (!realisation) {
            return;
        }

        if (realisation.paid) {
            return 'Niet goed te keuren omdat de uren al uitbetaald zijn';
        }

        if (!AuthorisationService.canApproveHours()) {
            return 'Geen rechten om uren goed te keuren';
        }

        if (AuthorisationService.hasFunctionality(Functionalities.CommonHourCheck)) {
            return;
        }

        // Check if realisation is a leave type that requires Hourcheck role
        if (Utils.isLeaveType(realisation)) {
            return 'Verlof wordt goedgekeurd door de administratie';
        }

        // Check if someone specific is assigned to check this user's hours
        if (realisation.user?.hours_checked_by || realisation.user?.hours_checked_by_role) {
            if (!AuthorisationService.canCheckUserHours(realisation.user)) {
                if (realisation.user.hours_checked_by) {
                    return `Alleen ${realisation.user?.hours_checked_user?.name} kan de uren goedkeuren`;
                } else if (realisation.user.hours_checked_by_role) {
                    return `Alleen gebruikers met de juiste rol kunnen de uren goedkeuren`;
                }
            }
        }
    }
}
